export const TAG_LIST_CONTACTS = 'CONTACTS_LIST';
export const TAG_CONTACT = 'CONTACT_MODEL';
export const TAG_CONTACT_DUPLICATES = 'CONTACT_DUPLICATES';
export const TAG_CONTACT_MISC = 'CONTACT_MISC';
export const TAG_LIST_MEETINGS = 'MEETINGS_LIST';
export const TAG_MEETING = 'MEETINGS_MODEL';
export const TAG_MEETING_MISC = 'MEETINGS_MISC';
export const TAG_LIST_USERS = 'USERS_LIST';
export const TAG_LIST_ROLES = 'ROLES_LIST';
export const TAG_ROLE = 'ROLE_MODEL';
export const TAG_LIST_USER_TICKETS = 'USER_TICKETS_LIST';
export const TAG_USER_TICKET = 'USER_TICKET';
export const TAG_LIST_ADMIN_TICKETS = 'ADMIN_TICKETS_LIST';
export const TAG_ADMIN_TICKET = 'ADMIN_TICKET';
export const TAG_NOTIFICATIONS = 'NOTIFICATIONS_MODEL';
export const TAG_LIST_FILES = 'FILES_LIST';
export const TAG_FILE = 'FILE_MODEL';
export const TAG_FILE_MISC = 'FILE_MISC';
export const TAG_LIST_ORGANIZATIONS = 'ORGANIZATIONS_LIST';
export const TAG_ORGANIZATION = 'ORGANIZATION_MODEL';
export const TAG_ORGANIZATION_MISC = 'ORGANIZATION_MISC';
export const TAG_LIST_PROJECTS = 'PROJECTS_LIST';
export const TAG_PROJECT = 'PROJECT_MODEL';
export const TAG_PROJECT_MISC = 'PROJECT_MISC';
export const TAG_LIST_LEADS = 'LEADS_LIST';
export const TAG_LEAD = 'LEAD_MODEL';
export const TAG_LIST_PA_CHATS = 'PA_CHATS_LIST';
